import store from '@/services/store';
import ResourceSvc from '@/services/resource.svc.js';
import RenewalOptInModal from './renewal-opt-in-modal.vue';
import { hasMarker, writeMarker } from '@/services/renewal-opt-in-marker.js';

const svc = new ResourceSvc();

const MODE_NONE = 'None';

export default {
    name: 'RenewalOptInCoordinator',
    components: {
        'renewal-opt-in-modal': RenewalOptInModal
    },
    data() {
        return {
            isModalVisible: false,
            eligibility: null,
            hasEvaluated: false
        };
    },
    computed: {
        userId() {
            const user = store.getters.getCurrentUser;
            return user && user.id ? user.id : 0;
        },
        isRouteSuppressed() {
            return !!(this.$route && this.$route.meta && this.$route.meta.suppressRenewalOptInModal);
        }
    },
    watch: {
        userId: {
            immediate: true,
            handler() {
                this.evaluate();
            }
        },
        $route: {
            immediate: true,
            handler() {
                this.evaluate();
            }
        }
    },
    methods: {
        async evaluate() {
            if (this.hasEvaluated || !this.userId || this.isRouteSuppressed) {
                return;
            }

            if (hasMarker(this.userId)) {
                this.hasEvaluated = true;
                return;
            }

            this.hasEvaluated = true;

            try {
                const response = await svc.getRenewalOptInEligibility();
                const result = response && response.body;

                if (!result || !result.mode || result.mode === MODE_NONE) {
                    return;
                }

                if (!writeMarker(this.userId)) {
                    return;
                }

                this.eligibility = result;
                this.isModalVisible = true;
            } catch (e) {
                this.eligibility = null;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/membership-renewal-opt-in/renewal-opt-in-coordinator.js